import { render, staticRenderFns } from "./SQLPreview.vue?vue&type=template&id=4dfb3323&"
import script from "./SQLPreview.vue?vue&type=script&lang=js&"
export * from "./SQLPreview.vue?vue&type=script&lang=js&"
import style0 from "./SQLPreview.vue?vue&type=style&index=0&id=4dfb3323&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports